import React, { useEffect, useMemo } from 'react'
import { Select } from '../../../../components'
import './responsavelparticipantes.scss'

const Responsavelparticipantes = ({
  usuarios,
  loadingUsers,
  nls,
  value,
  onChange
}) => {
  const responsavelSelecionado = value?.responsavel || {}
  const participantesSelecionados = Array.isArray(value?.participantes) ? value.participantes : []

  const selectTextCustom = {
  selecione: nls.selectPlaceholder,
  selecionado: nls.selectSelected,
  selecionados: nls.selectSelectedPlural,
  todos: nls.selectAll
}

  const responsavelOptions = useMemo(() => {
    if (!Array.isArray(usuarios)) return []

    return usuarios.filter(item => {
      return !participantesSelecionados.some(participante => participante?.value === item?.value)
    })
  }, [usuarios, participantesSelecionados])

  const participantesOptions = useMemo(() => {
    if (!Array.isArray(usuarios)) return []

    return usuarios.filter(item => item?.value !== responsavelSelecionado?.value)
  }, [usuarios, responsavelSelecionado])

  useEffect(() => {
    if (
      responsavelSelecionado?.value &&
      participantesSelecionados.some(item => item?.value === responsavelSelecionado?.value)
    ) {
      onChange({
        ...value,
        participantes: participantesSelecionados.filter(item => item?.value !== responsavelSelecionado?.value)
      })
    }
  }, [responsavelSelecionado, participantesSelecionados, value, onChange])

  const handleSelecionarResponsavel = e => {
    const novoResponsavel = e?.value || {}

    onChange({
      ...value,
      responsavel: novoResponsavel,
      participantes: participantesSelecionados.filter(item => item?.value !== novoResponsavel?.value)
    })
  }

  const handleSelecionarParticipantes = e => {
    const novosParticipantes = Array.isArray(e?.value) ? e.value : []

    onChange({
      ...value,
      participantes: novosParticipantes.filter(item => item?.value !== responsavelSelecionado?.value)
    })
  }

  return (
    <div className='aprovarplanoplan-responsavelparticipantes'>
      <div className='aprovarplanoplan-responsavelparticipantes__title'>
        {nls.blockResponsibleParticipantsTitle}
      </div>

      <div className='aprovarplanoplan-responsavelparticipantes__content'>
        <div className='aprovarplanoplan-responsavelparticipantes__field'>
          <Select
            name='responsavelExecutar'
            label={nls.responsibleLabel}
            options={responsavelOptions}
            selected={responsavelSelecionado || {}}
            action={handleSelecionarResponsavel}
            optionLabel='label'
            optionValue='value'
            selectedItem={false}
            textCustom={selectTextCustom}
            filter
            disabled={loadingUsers}
          />
        </div>

        <div className='aprovarplanoplan-responsavelparticipantes__field'>
          <Select
            name='participantes'
            label={nls.participantsLabel}
            options={participantesOptions}
            selected={participantesSelecionados || []}
            action={handleSelecionarParticipantes}
            optionLabel='label'
            optionValue='value'
            selectedItem={false}
            textCustom={selectTextCustom}
            multiSelect
            filter
            disabled={loadingUsers}
          />
        </div>

        <div className='aprovarplanoplan-responsavelparticipantes__helper'>
          {nls.responsibleParticipantsHelper}
        </div>
      </div>
    </div>
  )
}

export default Responsavelparticipantes